import { SingleCombobox } from '@commenda/kakashi';
import { State } from 'country-state-city';
import { useMemo } from 'react';
import { StateSelectorProps } from '../../types';

// US states that support sales tax filing
const SUPPORTED_STATE_CODES = [
  'AL',
  'AK',
  'AZ',
  'AR',
  'CA',
  'CO',
  'CT',
  'DC',
  'FL',
  'GA',
  'HI',
  'ID',
  'IL',
  'IN',
  'IA',
  'KS',
  'KY',
  'LA',
  'ME',
  'MD',
  'MA',
  'MI',
  'MN',
  'MS',
  'MO',
  'NE',
  'NV',
  'NJ',
  'NM',
  'NY',
  'NC',
  'ND',
  'OH',
  'OK',
  'PA',
  'RI',
  'SC',
  'SD',
  'TN',
  'TX',
  'UT',
  'VT',
  'VA',
  'WA',
  'WV',
  'WI',
  'WY',
];

export function StateSelector({
  value,
  onChange,
  disabled = false,
  error,
  registrations,
}: StateSelectorProps) {
  const stateOptions = useMemo(() => {
    const allUSStates = State.getStatesOfCountry('US');

    // Get list of states that have registrations
    const registeredStateCodes = registrations
      ? registrations.map((reg) => reg.state)
      : [];

    return allUSStates
      .filter(
        (state) =>
          SUPPORTED_STATE_CODES.includes(state.isoCode) &&
          registeredStateCodes.includes(state.isoCode)
      )
      .map((state) => ({
        value: state.isoCode,
        label: state.name,
      }))
      .sort((a, b) => a.label.localeCompare(b.label));
  }, [registrations]);

  return (
    <div className="flex flex-col gap-1.5">
      <label className="txt-small-medium text-text-secondary">
        States with registration
        <span className="txt-small-medium text-utility-violet-600 ml-0.5">
          *
        </span>
      </label>
      <SingleCombobox
        value={value}
        setValue={onChange}
        options={stateOptions}
        placeholder="Select state"
        searchPlaceholder="Search states..."
        notFoundText="No states found"
        disabled={disabled}
        canClearSelection={false}
        error={error}
        _className="txt-medium-regular text-text-secondary h-11 px-3"
        renderTrigger={({ selectedOption, placeholder }) => (
          <span className="txt-medium-regular text-text-secondary">
            {selectedOption?.label || placeholder}
          </span>
        )}
      />
      {error && (
        <p className="txt-xs-regular text-utility-error-500">{error}</p>
      )}
    </div>
  );
}
